module.exports = __webpack_public_path__ + "media/images/athletes/442-0cf602b3d3f32d189384155e55f7ad5e.png";